import { FC, forwardRef, memo, useMemo, useRef } from "react";
import theme from "theme";
import useCombinedRefs from "utils/useCombinedRefs";
import { WithStyle } from "../../utils/WithStyle";
import { Text } from "../Text/Text.component";
import { Container, Radio } from "./RadioButton.styled";
import { RadioButtonProps } from "./types";

const Component: FC<RadioButtonProps> = memo(
    forwardRef(
        ({
            ref,
            label,
            fullWidth,
            id = "radioButton",
            labelColor,
            disabled = false,
            ...restProps
        }) => {
            const inputRef = useCombinedRefs<HTMLInputElement>(
                ref,
                useRef(null)
            );
            const isChecked = useMemo(() => {
                if (inputRef && inputRef.current) {
                    return inputRef.current.checked;
                }
            }, [inputRef]);
            return (
                <Container fullWidth={fullWidth} htmlFor={id}>
                    <Radio type="radio" id={id} {...restProps} ref={inputRef} disabled={disabled} />
                    <Text
                        as="label"
                        variant="label"
                        htmlFor={id}
                        color={
                            isChecked
                                ? theme.colors.grey.dark
                                : theme.colors.grey.primary
                        }
                        disabled={disabled}
                    >
                        {label}
                    </Text>
                </Container>
            );
        }
    )
);

export const RadioButton: FC<RadioButtonProps> & WithStyle = Object.assign(
    Component,
    {
        Style: Container,
    }
);
